import type {EditorElement} from '@wix/ambassador-devcenter-v1-component-type-data/types'
import type {DisplayFilters} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {ManifestFeatureComponentStageGfpp} from '@wix/document-services-types'
import {DisplayFiltersCustomActionsBuilder} from './DisplayFiltersCustomActionsBuilder'
import {DisplayFiltersNativeActionsBuilder} from './DisplayFiltersNativeActionsBuilder'
import {DisplayFiltersDataBuilder} from './DisplayFiltersDataBuilder'
import type {BUILDER_COMPONENT_MAP} from '../elements/BaseElementBuilder'

export class DisplayFiltersBuilder {
    constructor(
        private readonly gfpp: ManifestFeatureComponentStageGfpp | undefined,
        private readonly componentType?: keyof typeof BUILDER_COMPONENT_MAP,
        private readonly builderData?: EditorElement['data']
    ) {}

    build = (): DisplayFilters => {
        return {
            customActions: new DisplayFiltersCustomActionsBuilder(this.gfpp).build(),
            actions: new DisplayFiltersNativeActionsBuilder(this.gfpp, this.componentType).build(),
            data: new DisplayFiltersDataBuilder(this.builderData).build()
        }
    }
}
